new Swiper('.custom-product .main-slider', {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  pagination: {
    el: '.custom-product .swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.custom-product .swiper-button-next',
    prevEl: '.custom-product .swiper-button-prev',
  },
  thumbs: {
    swiper: '.custom-product .thumbnails-slider',
  },
});

new Swiper('.custom-product .thumbnails-slider', {
  slidesPerView: 6,
  spaceBetween: 12,
  loop: false,
});